import { render, staticRenderFns } from "./UserFileProcess.vue?vue&type=template&id=180b0910&scoped=true&"
import script from "./UserFileProcess.vue?vue&type=script&lang=js&"
export * from "./UserFileProcess.vue?vue&type=script&lang=js&"
import style0 from "./UserFileProcess.vue?vue&type=style&index=0&id=180b0910&prod&scoped=true&lang=css&"
import style1 from "./UserFileProcess.vue?vue&type=style&index=1&id=180b0910&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b0910",
  null
  
)

export default component.exports